import React from 'react'
import { Accordion, Container, Icon } from 'semantic-ui-react'
import styled from 'styled-components'
import wrapCategory from 'components/categories/wrapCategory'
import { blue, lightRed } from 'theme.js'
import { Link } from 'react-router-dom'

const Wrapper = styled.div`
  a {
    display: block;
  }

  .title {
    &:hover {
      color: white !important;
      background: ${blue};
    }

    &.active {
      color: white !important;
      background: ${blue};
    }
  }

  .content {
    &.active {
      background: ${lightRed};
    }
  }
`

const KeysListing = ({ id }) => {
  return (
    <Wrapper>
      <Accordion.Title as={Link} to={`/${id}/keys`}>
        <Container className="category-title">
          ключи
          <Icon name="external" />
        </Container>
      </Accordion.Title>
    </Wrapper>
  )
}

export default wrapCategory(KeysListing)
